import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axiosInstance from "./axios";
import PrimeVue from "primevue/config";

import Button from "primevue/button";
import Dialog from "primevue/dialog";
import OrganizationChart from "primevue/organizationchart";
import Dropdown from "primevue/dropdown";
import Tooltip from "primevue/tooltip";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup"; // optional
import Row from "primevue/row";
import ScrollPanel from 'primevue/scrollpanel';
import Sidebar from 'primevue/sidebar';
import Tree from 'primevue/tree';
import hljs from 'highlight.js/lib/core';
import sql from 'highlight.js/lib/languages/sql';

import 'highlight.js/styles/github.css'; 
import "primeflex/primeflex.css";
import "primevue/resources/themes/soho-light/theme.css";
import "primevue/resources/primevue.min.css"; /* Deprecated */
import "primeicons/primeicons.css";

// 设置 axios 的全局默认配置
hljs.registerLanguage('sql', sql);
const app = createApp(App);
app.config.globalProperties.$hljs = hljs;
// 设置 axios 为全局可用的属性，这样可以在任何组件中通过 this.$axios 访问
app.config.globalProperties.$axios = axiosInstance;

// 使用 Vuex 状态管理
app.use(store);

// 使用 Vue Router
app.use(router);

app.use(PrimeVue);

//注册组件
app.directive("tooltip", Tooltip);
app.component("Dropdown", Dropdown);
app.component("Button", Button);
app.component("Dialog", Dialog);
app.component("OrganizationChart", OrganizationChart);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Row", Row);
app.component("ScrollPanel", ScrollPanel);
app.component("Sidebar",Sidebar)
app.component("Tree",Tree)

// 将 Vue 实例挂载到 #app 元素上
app.mount("#app");
